/* eslint-disable no-await-in-loop */
import { setFetchDefaults } from '../actions/entities/io';
import { loadBookPartials } from './../../redux/helpers/loadBook';
import { loadSpineDefaults } from '../actions/entities/cover';

import {
  loadLayouts,
  setIsActiveLayout,
} from '../actions/entities/layouts';

import {
  setLayoutToActivePage,
  setIsActive,
  createPage,
} from '../actions/entities/pages';

import {
  getParam,
  getDomain,
} from './getParams';

import {
  addBookId,
  addContext,
  addFolderId,
  addDefaultText,
  addParentStyle,
} from '../actions/bookproperties';

import {
  configExist,
  generateId,
  showAlertModal,
} from './';

import { generateWeddingTexts, DEFAULT_FONT, DEFAULT_STANDARD_FONT, DEFAULT_TEXT_COLOR } from './texts';
import { tableNumber, generateTableNumbers, setGeneratedTextToCorrectPosition, placeCard, getParentStyle, setParentBackground, loadProductBackgrounds, setFontSizeByParentFont, guestBook, letterOfInvitation, letterOfInvitationLandscape, letterOfInvitationPortrait, sticker } from './../../helpers/weddingHelper';
import { setWeddingTextStatus } from '../actions/ui/weddingTextGenerated';

export function setFirstLayout(store, layoutId, pageId, firstPage = false) {
  // store.dispatch(addCoverToPage(pageId));
  store.dispatch(setLayoutToActivePage(layoutId, pageId));
  store.dispatch(setIsActiveLayout(layoutId));
  store.dispatch(loadSpineDefaults());
  store.dispatch(setFetchDefaults());
  if (firstPage) {
    store.dispatch(setIsActive(pageId));
  }
}

export async function loadDefaultState(store, bookId = false, autoFill = false, bookContext, lang) {
  const referer = getDomain();

  const page = {
    layout: 0,
    placeholders: [],
    order: 0,
    isActive: true,
  };

  // Load book properties
  const getBookProperties = configExist('getStateUrl', referer);
  const fetchURL = `${getBookProperties}/${bookId}/editorjson`;

  // setNewBook(store, response, layoutId, bookId, pageId, referer, lang, autoFill);
  /* ------ */
  await fetch(fetchURL, {
    cors: 'no-cors',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
  })
    .then(response => response.json())
    .then(async (data) => {
      if ('error' in data) {
        throw data.error;
      }

      let { json } = data;

      // Load book
      if ('entities' in json) {
        const updateSavedProtocol = await updateProtocol();
        json = updateSavedProtocol.success;
        return loadBookPartials(json, store.dispatch);
      }


      // Set New book
      const { folderID, productType } = json;

      store.dispatch(addFolderId(folderID));
      store.dispatch(addBookId(parseInt(getParam('productId'), 10)));
      store.dispatch(addContext(bookContext));
      store.dispatch(loadLayouts(json.pages));
      await loadProductBackgrounds(store.dispatch, productType);

      if ((productType === letterOfInvitationLandscape) || productType === letterOfInvitationPortrait) {
        await loadProductBackgrounds(store.dispatch, sticker);
      }

      if ('defaultText' in json) {
        store.dispatch(addDefaultText(json.defaultText));
      }

      const getParentStyles = await getParentStyle(bookId);
      const setParentFontStype = {};

      if (getParentStyles.success !== null) {
        const { success: parentSt } = getParentStyles;
        store.dispatch(addParentStyle(parentSt));

        const getCreative = Object.values(parentSt).find(el => ('text' in el ? el.text.type === 'Creative' : null));
        const getStandard = Object.values(parentSt).find(el => ('text' in el ? el.text.type === 'Standard' : null));

        if ((json.productType !== placeCard) && (json.productType !== tableNumber)) {
          for (const [index, el] of json.pages.entries()) {
            if ('texts' in el) {
              const { texts } = el;
              for (const [fontIndex, text] of texts.entries()) {
                const { type } = text;

                let getParentFont = getStandard ? getStandard.text.font : DEFAULT_STANDARD_FONT;
                let getParentColor = getStandard ? getStandard.text.color : DEFAULT_TEXT_COLOR;
                if (type === 'Creative') {
                  getParentFont = getCreative ? getCreative.text.font : DEFAULT_FONT;
                  getParentColor = getCreative ? getCreative.text.color : DEFAULT_TEXT_COLOR;
                }


                const getFontSize = await setFontSizeByParentFont(getParentFont, json.productType, lang);

                Object.assign(setParentFontStype, {
                  [type]: {
                    fontSize: getFontSize,
                    color: getParentColor,
                    font: getParentFont,
                    index: fontIndex,
                  },
                });
              }
            }
          }
        }
      }

      if (json.productType === tableNumber) {
        const { quantity } = json;
        store.dispatch(setWeddingTextStatus(true));
        await generateTableNumbers(quantity, store, page, json);
        await setGeneratedTextToCorrectPosition(store);
        store.dispatch(setWeddingTextStatus(false));
        await setParentBackground(getParentStyles, store);
      } else {
        for (const [index, el] of json.pages.entries()) {
          if (json.productType !== placeCard) {
            const state = store.getState();
            const pageId = generateId(state.entities.pages.allIds);
            store.dispatch(createPage(Object.assign({}, page, { order: index })));
            // set defaults text
            if ('texts' in el) {
              const { texts } = el;
              for (const [fontIndex, text] of texts.entries()) {
                await generateWeddingTexts(store, text, pageId, setParentFontStype, fontIndex, index);
              }
            }

            const firstPage = index === 0;
            const layoutId = store.getState().entities.layouts.allIds;
            const newPageId = store.getState().entities.pages.allIds;
            setFirstLayout(store, layoutId[index], newPageId[index], firstPage);
          }
        }

        if (json.productType !== placeCard) {
          await setParentBackground(getParentStyles, store);
        }

        setGeneratedTextToCorrectPosition(store);
      }
      if (!getParentStyles.success) {
        showAlertModal(lang.title_notice, lang.select_background);
      }
    });
}


export async function updateProtocol() {
  const referer = getDomain();
  const legacyUrl = configExist('legacyUrl', referer);
  const updateUrl = await fetch(`${legacyUrl}/api/wedding/id/${getParam('productId')}/updateProtocolInEditorJsonForweddingProducts`, {
    cors: 'no-cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const updatedData = await updateUrl.json();
  return updatedData;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadDefaulState.js